import { render, staticRenderFns } from "./finalizarHistoria.vue?vue&type=template&id=3ff7b512&scoped=true"
import script from "./finalizarHistoria.vue?vue&type=script&lang=js"
export * from "./finalizarHistoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff7b512",
  null
  
)

export default component.exports